import util from '@bmp-vue/core/api/util'

const controller = 'Bureau'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ConsultaSCR: function (dto) {
    return util.Axios.Post(controller + '/ConsultaSCR', dto)
  },
  GerarExcelSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcelSCR', dto)
  },
  GerarCSVSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarCSVSCR', dto)
  },
  GerarPDFSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSCR', dto)
  },
  ConsultaDataBusca: function (dto) {
    return util.Axios.Post(controller + '/ConsultaDataBusca', dto)
  },
  GerarPDFDataBusca: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFDataBusca', dto)
  },
  GerarPDFSPC: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSPC', dto)
  },
  ConsultaEmailAge: function (dto) {
    return util.Axios.Post(controller + '/ConsultaEmailage', dto)
  },
  GerarPDFEmailAge: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFEmailAge', dto)
  },
  NegativacoesSerasa (th, response) {
    th.model.SerasaConsultaDetalhe.push({
      NomeCredor: response?.creditorName || null,
      Valor: response?.amount || 0,
      DataOcorrencia: response?.occurrenceDate || null,
      Natureza: response?.legalNature || null,
      Contrato: response?.contractId || null,
      UF: response?.federalUnit || null,
      Cidade: response?.city || null,
      Banco: response?.bankName || null,
      Agencia: response?.bankAgencyId || null,
      Cheque: response?.checkNumber || null,
      QtdeCheques: response?.checkCount || null,
      Oficio: response?.officeNumber || null,
    });
  },
  FatosSerasa (th, response) {
    th.model.SerasaConsultaDetalhe.push({
      NomeEmpresa: response?.companyName || null,
      ApelidoEmpresa: response?.companyAlias || null,
      DocumentoEmpresa: response?.companyDocumentId || null,
      Valor: response?.amount || 0,
      DataOcorrencia: response?.occurrenceDate || null,
      Consultor: response?.segmentDescription || null,
      Natureza: response?.legalNature || null,
      VaraJudicial: response?.civilCourt || null,
      Distribuidor: response?.distributor || null,
      UF: response?.federalUnit || null,
      Cidade: response?.city || null,
    });
  },
  MontaOptionsSerasa (th, dados, chave) {
    if (!dados?.[chave]) return;
    const func = chave === 'facts'
      ? this.FatosSerasa
      : this.NegativacoesSerasa;
    const keys = Object.keys(dados[chave]);
    keys.forEach((item) => {
      const registros = dados[chave][item]?.[item + 'Response'] || dados[chave][item]?.results;
      if (Array.isArray(registros)) {
        registros.forEach((response) => func.call(this, th, response));
      }
    });
  },
  RetornoSerasaPF (th, data, options) {
    th.model.SerasaConsultaDetalhe = []
    th.model.SerasaPF = {
      Nome: data.registration.consumerName || '----',
      DtNasc: data.registration.birthDate || '----',
      DocumentoFederal: data.registration.documentNumber || '----',
      EstadoCivil: data.partner || null,
      Situacao: data.registration.statusRegistration || '----',
      DtSituacao: data.registration.statusDate || '----',
      NomeMae: data.registration.motherName || '----',
      Score12Meses: data.score.score || '----',
      Score12MesesMSG: data.score.message || '----',
    }
    if (data?.negativeData) this.MontaOptionsSerasa(th, data, 'negativeData')
    if (data?.facts) this.MontaOptionsSerasa(th, data, 'facts')
    if (options?.negativeData) this.MontaOptionsSerasa(th, options, 'negativeData')
    if (options?.facts) this.MontaOptionsSerasa(th, options, 'facts')
  },
  RetornoSerasaPJ (th, data, options) {
    const dataAtual = new Date().toISOString();
    th.model.SerasaConsultaDetalhe = []
    th.model.SerasaPJ = {
      NomeRzaoSocial: data.registration?.companyName || '----',
      DtFundacao: data.registration?.foundationDate || '----',
      DocumentoFederal: data.registration?.companyDocument || '----',
      UF: data.registration?.address.state || '----',
      Situacao: data.registration?.statusRegistration || '----',
      DtSituacao: data.registration?.statusDate || dataAtual,
      NomeMae: data.registration?.motherName || '----',
      Score: data?.score?.score || '----',
      Inadimplencia: data?.score?.defaultRate || '----',
      ScoreMensagem: data?.score?.message || '----',
    }
    if (data?.negativeData) this.MontaOptionsSerasa(th, data, 'negativeData')
    if (data?.facts) this.MontaOptionsSerasa(th, data, 'facts')
    if (options?.negativeData) this.MontaOptionsSerasa(th, options, 'negativeData')
    if (options?.facts) this.MontaOptionsSerasa(th, options, 'facts')
  },
  FormataRetornoSerasa (th, data) {
    const dados = data.JSON
    const parsedData = dados ? JSON.parse(dados)?.reports[0] : data.reports[0]
    const parsedOptions = dados ? JSON.parse(dados)?.optionalFeatures : data.optionalFeatures
    const func = parsedData?.registration?.documentNumber?.length === 11
      ? this.RetornoSerasaPF
      : this.RetornoSerasaPJ
    func.call(this, th, parsedData, parsedOptions);
  },
  ConsultaSerasa: function (th, dto) {
    const documento = dto.consulta.Documento
    const path = th.$aux.TipoPessoaEnum.PF === th.$api.Helper.RetornoTipoPessoa(documento) ? 'ConsultaSerasaCpf' : 'ConsultaSerasaCnpj';
    return th.$api.Multiplo.Post(path, dto)
      .then((response) => {
        if (response?.Falha === false && th.$api.UI.PostLoadData(response)) {
          return response
        }
        return this.NormalizaErroSerasa(th, response)
      })
      .catch(() => this.NormalizaErroSerasa(th))
  },
  // Erro HTTP (mensagem em "mensagem"), Falha:true, falha de rede ou resposta vazia viram o formato
  // que as telas já tratam ({ HasError, Falha, Result, Msg }); quem exibe a mensagem é a tela.
  NormalizaErroSerasa (th, response) {
    const mensagem = [response?.Msg, response?.mensagem]
      .find(m => typeof m === 'string' && m.trim() && !/^\s*[<{[]/.test(m))
    return {
      HasError: true,
      Falha: true,
      Result: false,
      Msg: mensagem
        ? mensagem.trim()
        : th?.$getErrorMessage?.('generic')?.message || 'Ocorreu um erro inesperado. Por favor tente novamente mais tarde.',
    }
  },
  GerarPDFSerasa: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSerasa', dto)
  },
  GerarPDFAllCheck: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFAllCheck', dto)
  },
  baseBureaus: [
    { id: 0, value: 'databusca', text: 'DATA BUSCA' },
    { id: 1, value: 'serasa', text: 'SERASA' },
    { id: 2, value: 'scr', text: 'SCR BACEN' },
  ],
  async validaBureaus (th, documentoCliente, bureaus, callback) {
    try {
      const dataAnterior = th.$api.UI.Date.AddDay(new Date(), -45)
      const dataFormatada = th.$api.UI.Format.Date(dataAnterior, 'yyyy-MM')
      const [dataBaseAno, dataBaseMes] = dataFormatada.split('-')

      const [resultadoDataBusca, resultadoScr, resultadoSerasa] = await Promise.all([
        this.consultarDataBuscaSeNecessario(th, documentoCliente, bureaus.databusca),
        this.consultarSCRSeNecessario(th, documentoCliente, dataBaseAno, dataBaseMes, bureaus.scr),
        this.consultarSerasaSeNecessario(th, documentoCliente, bureaus.serasa)
      ])

      if (resultadoDataBusca) bureaus.databusca = resultadoDataBusca
      if (resultadoScr) bureaus.scr = resultadoScr
      if (resultadoSerasa) bureaus.serasa = resultadoSerasa

      th.model.DadosBureau = bureaus
      callback()
    } catch (error) {
      th.$api.UI.ShowError('Erro em validação dos bureaus', error)
    }
  },
  consultarDataBuscaSeNecessario (th, documento, bureauExistente) {
    if (!bureauExistente || bureauExistente.Error) {
      return th.$api.Multiplo.Post('ConsultaDataBusca', {
        consulta: { Documento: documento }
      })
    }
    return null
  },
  consultarSCRSeNecessario (th, documento, ano, mes, bureauExistente) {
    if (!bureauExistente || bureauExistente.Error) {
      return th.$api.Multiplo.Post('ConsultaSCR', {
        consulta: {
          Documento: documento,
          DataBaseAno: ano,
          DataBaseMes: mes
        }
      })
        .then((response) => (response?.Erro === false && th.$api.UI.PostLoadData(response))
          ? response
          : this.NormalizaErroSerasa(th, response))
        .catch(() => this.NormalizaErroSerasa(th))
    }
    return null
  },
  consultarSerasaSeNecessario (th, documento, bureauExistente) {
    if (!bureauExistente || bureauExistente.Error) {
      return th.$api.Bureau.ConsultaSerasa(th, {
        consulta: { Documento: documento }
      })
    }
    return null
  }
})
